__turbopack_context__.v({
  "compareSectionWrapper": "CompareSection-module-scss-module__WVUItG__compareSectionWrapper",
});
